<!--
    @Author : Luo
    @Time   : 2020/8/8 9:44
-->
<template>
  <div class="account_analysis_page">
    <div :class="'page_nav' + (!catAccountStatus ? ' page_nav_full' : '')">
      <div class="page_nav_header flex_center">
        <template v-if="catAccountStatus">
          <router-link :to="{path: '/home/user/index', query: {team: teamIndex}}">
            <span>账号概览</span>
          </router-link>
        </template>
        <template v-else>
          <router-link :to="{path: '/home/user/index', query: {account: 'true', team: catUserInfo['team'], id: catUserInfo['id'], name: catUserInfo['name']}}">
            <span>账号概览</span>
          </router-link>
        </template>
        <div class="page_nav_breadcrumb"><span>/</span></div>
        <div class="now_page_label">
          <span>页面分析</span>
        </div>
      </div>
      <div class="page_nav_content flex_center">
        <div class="account_info_item flex_center">
          <div class="account_info_container flex_center account_user" v-if="accountDate.firstname && accountDate.firstname.length > 0">
            <div class="account_label">
              <span>用户名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.firstname }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_user" v-if="accountDate.account && accountDate.account.length > 0">
            <div class="account_label">
              <span>账号</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.account }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_user" v-if="accountDate.nickname && accountDate.nickname.length > 0">
            <div class="account_label">
              <span>微信名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.nickname }}</span>
            </div>
          </div>
        </div>
        <div class="account_info_item flex_center">
          <div class="account_info_container flex_center account_client">
            <div class="account_label flex_center">
              <span>客户数量&nbsp;&nbsp;{{ accountDate.clientTotal }}</span>
            </div>
            <div class="account_info_content flex_center">
                <span v-for="(clientItem, clientI) in accountDate.client" :key="clientI">
                  {{ clientItem[0] }} {{ clientItem[1] }}
                </span>
            </div>
          </div>
          <div class="account_info_container flex_center account_active">
            <div class="account_label">
              <span>帐号活跃比</span>
            </div>
            <div class="account_info_content flex_center">
              <span>{{ accountDate.active }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="account_page_container">
      <div class="account_page_header flex_center">
        <div class="page_wait_time flex_center">
          <div class="page_wait_time_container flex_center">
            <div class="page_wait_time_info"><span>{{ setTimeType(pageTotalTime.all) }}</span></div>
            <div class="page_wait_time_label"><span>停留总时长</span></div>
          </div>
          <div class="page_wait_time_container flex_center">
            <div class="page_wait_time_info"><span>{{ setTimeType(pageTotalTime.top) }}</span></div>
            <div class="page_wait_time_label"><span>前十总时长</span></div>
          </div>
        </div>
        <div class="account_page_search flex_center">
          <div class="input_container">
            <select @change="setClient" v-model="clientSelect.index">
              <option v-for="(item, i) in clientSelect.arr"
                      :key="i"
                      :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="input_container">
            <select @change="setPage" v-model="pageSelect.index">
              <option v-for="(item, i) in pageSelect.arr"
                      :key="i"
                      :value="item.id">{{ item.title }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="account_page_main text_left">
        <div class="account_page_main_header flex_center">
          <div class="account_page_main_client"><span>客户</span></div>
          <div class="account_page_main_member"><span>成员数</span></div>
          <div class="account_page_main_page"><span>页面</span></div>
          <div class="account_page_main_time"><span>停留时间</span></div>
        </div>
        <div class="account_page_main_list flex_center">
          <div class="no_user_hint text_center" v-if="JSON.stringify(tempClientDate).length <= 2"><span>{{ noDataHint }}</span></div>
          <div class="account_page_main_client_container flex_center" v-for="(item, i) in tempClientDate['current' + pagination.current]" :key="i">
            <div class="account_page_main_client"><span>{{ item.client }}</span></div>
            <div class="account_page_main_member"><span>{{ item.member }}</span></div>
            <div class="account_page_main_page"><span>{{ item.page }}</span></div>
            <div class="account_page_main_time"><span>{{ setTimeType(item.time) }}</span></div>
          </div>
        </div>
      </div>
      <div>
        <pagination :key="pagination.length" :default-current="pagination.current" :length="pagination.length" :default-amount="pagination.amount" v-on:pageCurrent="pageCurrent" />
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination/index'
import { _Ajax, initLogin, logout } from '@/api/_axios'
import { newMap, setTimeType, resetSpecNum } from '@/components/common/common_js'

export default {
  name: 'accountAnalysisPage',
  components: {
    pagination
  },
  data () {
    return {
      title: '',
      setTimeType: setTimeType,
      resetSpecNum: resetSpecNum,
      pageTotalTime: {all: 0, top: 0},
      accountDate: {},
      teamIndex: 0,
      accountId: null,
      clientSelect: {index: 0, arr: []},
      pageSelect: {index: 0, arr: []},
      clientDate: [],
      tempClientDate: {},
      noDataHint: '',
      pagination: {
        length: 0,
        amount: 10,
        current: 1
      },
      catAccountStatus: true,
      catUserInfo: {}
    }
  },
  methods: {
    setClient: function () {
      this.getClientPageDate(this.accountId,
        this.clientSelect.index === 0 ? undefined : this.clientSelect.index,
        this.pageSelect.index === 0 ? undefined : this.pageSelect.index)
    },
    setPage: function () {
      this.getClientPageDate(this.accountId,
        this.clientSelect.index === 0 ? undefined : this.clientSelect.index,
        this.pageSelect.index === 0 ? undefined : this.pageSelect.index)
    },
    // 设置客户的数据 arr: 数组, amount: 条目
    setUserDate: function (arr) {
      let tempArr = []
      let amount = this.pagination.amount
      let tempAmount = Math.ceil(this.pagination.length / amount)
      this.tempClientDate = {}
      for (let i = 1; i <= tempAmount; i++) {
        newMap(arr, (e, j) => {
          if (amount * ((i - 1) <= 0 ? 0 : i - 1) <= j && amount * i > j) {
            tempArr.push(e)
          }
        })
        this.tempClientDate['current' + i] = tempArr
        tempArr = []
      }
    },
    pageCurrent: function (data) {
      this.pagination.current = data.current
      // 选择每页显示条数的时候在刷新列表、条目及组件
      if (data.event === 'amount') {
        this.pagination.amount = data.amount
        this.setUserDate(this.clientDate)
      }
    },
    // 获取客户换看视频数据
    getClientPageDate: function (id, client, page) {
      let that = this

      that.clearUserData()
      _Ajax(
        {
          method: 'get',
          url: '/data/user/page/' + id + (client ? '?client=' + client : '') + (page ? (client ? '&' : '?') + 'page=' + page : ''),
          clearCancelSource: true
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '账号概览 - 页面分析：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            if (res.code && res.code === 'err100104') {
              that.noDataHint = '暂无客户数据'
              that.$notice({type: 'error', content: `错误：该用户的页面分析${res.msg}`})
              return false
            }

            that.pageTotalTime.all = res.pateStayTotalTime
            that.pageTotalTime.top = res.pateStayTopTenTime

            // 客户列表
            that.clientSelect.arr = []
            that.clientSelect.arr.push({id: 0, name: '全部客户'})
            for (let item of res.clientList) {
              that.clientSelect.arr.push({id: Object.keys(item), name: Object.values(item)[0]})
            }

            // 页面列表
            that.pageSelect.arr = res.pageList
            that.pageSelect.arr.push({id: 0, title: '全部页面'})

            if (res.clientStayList && res.clientStayList.length > 0) {
              newMap(res.clientStayList, (e) => {
                that.clientDate.push({client: e.name, member: e.num, page: e.page, time: e.time_len})
              })
            }

            that.pagination.length = that.clientDate.length
            that.pagination.current = 1
            that.setUserDate(that.clientDate)

            if (that.pagination.length <= 0) {
              that.noDataHint = '暂无客户数据'
            }

            // 客户信息
            that.accountDate = {
              account: res.userName,
              clientTotal: res.clientNumTotal,
              active: that.resetSpecNum(res.activeProportion),
              client: res.clientStatus,
              firstname: res.firstname,
              nickname: res.nickname
            }
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    // 清空数据
    clearUserData: function () {
      let that = this

      that.noDataHint = '数据正在加载中...'
      that.pagination.length = 0
      that.pagination.current = 1
      that.clientDate = []
      that.setUserDate(that.clientDate)
    }
  },
  mounted () {},
  beforeMount: function () {
    let that = this
    let tempRoute = that.$route.query

    that.teamIndex = tempRoute.team
    that.accountId = tempRoute.id

    that.getClientPageDate(that.accountId,
      that.clientSelect.index === 0 ? undefined : that.clientSelect.index,
      that.pageSelect.index === 0 ? undefined : that.pageSelect.index)

    if (tempRoute.account && tempRoute.account === 'true') {
      that.catAccountStatus = false
      that.catUserInfo['name'] = tempRoute.name
      that.catUserInfo['team'] = Number(tempRoute.team)
      that.catUserInfo['id'] = tempRoute.accountId
    }
  },
  beforeCreate: function () {
    initLogin(this.$router)
  }
}
</script>

<style scoped>
.page_nav {position: absolute;top: 80px;padding: 20px 0 20px 28px;margin-left: -28px;width: calc(100vw - 272px);background-color: rgba(255, 255, 255, 1)}
.page_nav_full {width: 100%;min-width: 1306px}
.page_nav_content {flex-flow: column;align-items: flex-start;justify-content: flex-start;margin-top: 24px}
.account_info_item {justify-content: flex-start}
.account_info_item:not(:first-of-type) {margin-top: 20px}
.account_info_container {min-width: 260px;justify-content: flex-start}
.account_info_container:not(:first-of-type) {margin-left: 20px}
.account_client {width: 350px}
.account_label {white-space: nowrap}
.account_label span {font-size: 12px;font-weight: bold;color: rgba(102, 102, 102, 1)}
.account_info_content {margin-left: 16px}
.account_info_content span {font-size: 14px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.account_page_container {padding: 30px 32px;margin-top: 124px;background-color: rgba(255, 255, 255, 1);border-radius: 6px}
.account_page_header {justify-content: space-between}
.page_wait_time {justify-content: space-between}
.page_wait_time_container {justify-content: flex-start;flex-flow: column;align-items: flex-start}
.page_wait_time .page_wait_time_container:not(:first-of-type) {margin-left: 100px}
.page_wait_time_info span {font-size: 28px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.page_wait_time_label {margin-top: 12px}
.page_wait_time_label span {font-size: 16px;font-weight: 500;color: rgba(48, 48, 48, 1)}

.account_page_search {justify-content: flex-end}
.account_page_search .input_container:not(:first-of-type) {margin-left: 20px}
.input_container select {width: 164px;height: 32px;line-height: 32px;padding: 0 14px;border: 1px solid rgba(219, 219, 219, 1);border-radius: 4px;font-size: 14px;font-weight: 400;color: rgba(40, 40, 40, 1)}

.account_page_main {margin-top: 20px}
.account_page_main_header {justify-content: flex-start;padding: 0 23px;height: 50px;background-color: rgba(248, 248, 248, 1)}
.account_page_main_header span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.account_page_main_client_container {justify-content: flex-start;padding: 0 23px;width: calc(100% - 46px);height: 50px;border-bottom: 1px solid rgba(235, 235, 235, 1)}
.account_page_main_client_container span {font-size: 14px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.account_page_main_client {width: 300px}
.account_page_main_member {width: 240px}
.account_page_main_page {width: 240px}
.account_page_main_time {width: 150px}
.account_page_main_list {flex-flow: column;justify-content: flex-start;align-items: flex-start}

.no_user_hint {margin: 30px 0;width: 100%}
.no_user_hint span {font-size: 16px;font-weight: 500;color: rgba(143, 143, 143, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-user/account-analysis.vue